module.exports = __webpack_public_path__ + "assets/GoldOmicron.5bd1cbf672d7117e317ac073e0245910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldOmicron.png
// module id = 769
// module chunks = 0